const defer = (callback, timeout = 0) => {
    setTimeout(callback, timeout);
};

const createGhost = (element) => {
    const ghost = element.cloneNode(true);

    ghost.classList.add('ghost');

    ghost.style.position = 'absolute';

    ghost.style.top   = `${element.offsetTop}px`;
    ghost.style.left  = `${element.offsetLeft}px`;
    ghost.style.width = `${element.offsetWidth}px`;

    element.after(ghost);

    element.style.visibility = 'hidden';

    return ghost;
};

const moveNodes = (nodes) => {
    nodes.forEach((node, index) => {
        const ghost = createGhost(node.element);

        setTimeout(() => {
            ghost.classList.add(index === 0 ? 'target' : 'destination');

            defer(() => {
                ghost.style.top = `${node.newTop}px`

                Promise.all(ghost.getAnimations().map((animation) => animation.finished)).then(() => {
                    ghost.remove();

                    node.element.style.visibility = 'visible';

                    if (index === 0) {
                        node.element.parentNode.insertBefore(node.element, nodes[0].target)
                    }
                });
            });
        }, index * 50);
    });
};

const moveUp = (container, startPosition, destinationPosition) => {
    const nodes = [{
        element: container.children.item(startPosition - 1),
        target: container.children.item(destinationPosition - 1),
        newTop: container.children.item(destinationPosition - 1).offsetTop,
    }];

    container.querySelectorAll('li').forEach((element, index) => {
        if (index + 1 < destinationPosition) {
            return;
        }

        if (index + 1 >= startPosition) {
            return;
        }

        nodes.push({
            element: element,
            newTop: element.nextElementSibling.offsetTop,
        });
    });

    moveNodes(nodes);
};

const moveDown = (container, startPosition, destinationPosition) => {
    const nodes = [{
        element: container.children.item(startPosition - 1),
        target: container.children.item(destinationPosition),
        newTop: container.children.item(destinationPosition - 1).offsetTop,
    }];

    container.querySelectorAll('li').forEach((element, index) => {
        if (index + 1 <= startPosition) {
            return;
        }

        if (index + 1 > destinationPosition) {
            return;
        }

        nodes.push({
            element: element,
            newTop: element.previousElementSibling.offsetTop,
        });
    });

    moveNodes(nodes);
};

export const sort = (container, sourceIndex, destinationIndex) => {
    if (sourceIndex > destinationIndex) {
        moveUp(container, sourceIndex, destinationIndex);

        return;
    }

    moveDown(container, sourceIndex, destinationIndex);
};
